/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    username
    avatar {
      bucket
      region
      key
    }
  }
}
`;
export const listUsers = `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      avatar {
        bucket
        region
        key
      }
    }
    nextToken
  }
}
`;
export const getItem = `query GetItem($id: ID!) {
  getItem(id: $id) {
    id
    name
    description
    filename
    key
    avatar {
      bucket
      region
      key
    }
    userID
    dateUploaded
    dateEdited
    fileSize
  }
}
`;
export const listItems = `query ListItems(
  $filter: ModelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      filename
      key
      avatar {
        bucket
        region
        key
      }
      userID
      dateUploaded
      dateEdited
      fileSize
    }
    nextToken
  }
}
`;
